<div class="row justify-content-center m-0 flightTicketBox">
    <div class="col-lg-12 p-0 ticketBoxDiv">
        <div class="pb-0 payment-plan">
            <div *ngIf="!hasLimitExhausted">
                <div class="row justify-content-center">
                    <div class="col-12 col-md-8 text-center">
                        <h3>🎉 Congratulations! You're Approved!</h3>
                        <p>Your <b>Travel Now, Pay Later</b> loan is ready. <b>Choose an EMI plan that fits your
                                budget</b> and move
                            one step closer to your dream trip! ✈️​</p>
                        <p><b>🔹 Your Approved Loan Amount: {{ inPrincipleAmount | currency: 'INR':'symbol':'1.0-0'
                                }}</b></p>
                        <p>🚀 Select your plan now & lock in your loan!</p>
                    </div>
                </div>
                <div class="row justify-content-center">
                    <!-- 01 -->
                    <div class="plan-wrapper">
                        <!-- <div class="cards-container d-flex align-items-center justify-content-center flex-wrap">
                            <div class="row align-items-center justify-content-center">
                                <div class="col-12 col-md-6 col-lg-3 mb-4">
                                </div>
                                <div class="col-12 col-md-6 col-lg-3 mb-4" *ngFor="let plan of plans; let last = last">
                                    <app-emi-plan-card [plan]="plan" (selectedPlan)="SelectPlan(plan)"
                                    [isLastPlan]="last"></app-emi-plan-card>
                                </div>
                            </div>
                        </div> -->
                        @if(newPlans.length > 0) {
                        <app-plan-calculator [sliderLoanAmount]="Loanamount" [plans]="newPlans"
                            [isFromAssistPayment]="true" [mobile]="Mobile"
                            (selectedPlan)="handleUpdateSelectedPlan($event)"></app-plan-calculator>
                        }
                    </div>
                </div>
                <!-- 01 -->
                <div class="row justify-content-center" *ngIf="selectedPlan">
                    <div class="col-sm-7 col-11 col-lg-6">
                        <div class="backside">
                            <div class="card">
                                <div class="card-body text-center pt-0 pb-0">
                                    <div class="justify-content-center">
                                        <div class="row justify-content-center">
                                            <div class="col-5">
                                                <h4 class="card-title mt-3"> Pay now<br>
                                                    <span class="amount">&#8377; {{GeneratePayNow(selectedPlan)}}</span>
                                                </h4>
                                            </div>
                                            <div class="col-7">
                                                <h4 class="card-title mt-3"> EMI <br><span class="amount"> &#8377;
                                                        {{ FormatValRound(selectedPlan.emi_amount) }}</span> <small> x
                                                        {{selectedPlan.tenor}}</small></h4>
                                                <p class="note font-weight-bold">Due every 5<sup>th</sup> of month
                                                </p>
                                            </div>
                                        </div>
                                        <div class="row justify-content-center">
                                            <div class="col-12 p-0">
                                                <table class="table">
                                                    <tbody>
                                                        <tr>
                                                            <td width="70%">Processing fee including GST (pay today)
                                                            </td>
                                                            <td class="text-right"> &#8377;
                                                                {{GenerateProcessingFee(selectedPlan)}}</td>
                                                        </tr>
                                                        <tr>
                                                            <td width="70%">Downpayment (pay today)</td>
                                                            <td class="text-right"> &#8377;
                                                                {{FormatValRound(selectedPlan.downpayment)}}</td>
                                                        </tr>
                                                        <tr>
                                                            <td width="70%"><strong>Pay Today</strong></td>
                                                            <td class="text-right"><strong> &#8377;
                                                                    {{GeneratePayNow(selectedPlan)}}</strong></td>
                                                        </tr>
                                                    </tbody>
                                                    <tfoot>
                                                        <tr>
                                                            <td width="70%">Loan amount</td>
                                                            <td class="text-right"> &#8377;
                                                                {{ FormatValRound(selectedPlan.loan_amount) }}</td>
                                                        </tr>
                                                        <tr>
                                                            <td width="70%">Interest</td>
                                                            <td class="text-right"> &#8377;
                                                                {{GenerateInterest(selectedPlan)}}</td>
                                                        </tr>
                                                        <tr>
                                                            <td width="70%"><strong>Total payable</strong></td>
                                                            <td class="text-right"><strong> &#8377;
                                                                    {{GenerateTotalPayable(selectedPlan)}}</strong></td>
                                                        </tr>
                                                    </tfoot>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row justify-content-center text-center buttonDiv mt-2" *ngIf="isPlanSelected">
                    <div class="col-lg-3 col-sm-3 col-md-6 col-8">
                        <button type="submit" class="btn btn-warning btn-block" (click)="ProceedToNach()">Select EMI
                            Plan <i class="fas fa-arrow-right"></i></button>
                    </div>
                </div>
                <div class="text-center">
                    <span>Prices may increase soon—lock in your EMI now!</span>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- 
<div *ngIf="hasLimitExhausted">
    <div class="row justify-content-center mt-3 d-flex flex-lg-row-reverse">
        <div class="col-lg-6 col-12" style="align-self: center;">
            <div class="row justify-content-center">
                <div class="col-8 blue_box p-4 text-center">
                    <h3 class="heading">Sorry!</h3>
                </div>
            </div>
            <div class="row justify-content-center mt-4">
                <div class="col col-lg-11 col-md-11">
                    <p style="text-align: center;">You have exhausted your limit</p>
                    <div style="text-align: center;">
                        <img src="../../../../assets/images/creditLimit.png" alt="credit Limit" style="height: 5rem;">
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-5 col-11">
            <app-assist-left></app-assist-left>
        </div>
    </div>
</div> -->
<ngx-spinner type="ball-spin-clockwise" size="medium"></ngx-spinner>